<ng-container *ngIf="vm$ | async as vm">
    <app-autocomplete-multiselect
      [currentValue]="vm.defaultValue"
      [options]="vm.customerReasons"
      [noResoultsLabel]="'ci.common.noResults' | translate"
      [placeholder]="'ci.common.customerReason' | translate"
      (valueChange)="onValueChange($event)"
  ></app-autocomplete-multiselect>
</ng-container>
